import { useBusinessInfo } from '~/lib/Queries';
import useBusinessPostApi from '~/lib/useBusinessPostApi';
import { useState } from 'react';
import * as Toast from '~/lib/Toast';
import Loading from '~/components/Loading';

const MarkHipaa = () => {
    const { data: businessInfoData, isLoading } = useBusinessInfo();
    const { save: markHipaa, isSaving } = useBusinessPostApi('/mark-hipaa');
    const [isRedirecting, setIsRedirecting] = useState(false);

    const isAlreadyHipaa = businessInfoData?.hipaa;

    const handleMarkHipaa = () => {
        setIsRedirecting(true);
        markHipaa()
            .then((result) => {
                Toast.success(isAlreadyHipaa
                    ? 'Redirecting to sign BAA...'
                    : 'Business marked as HIPAA. Redirecting to sign BAA...');
                // Redirect to the HelloSign URL
                window.location.href = result.url;
            })
            .catch(() => {
                Toast.error('Failed to mark business as HIPAA. Please try again.');
                setIsRedirecting(false);
            });
    };

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div>
            <h1 className="page-heading">Mark HIPAA</h1>

            {isAlreadyHipaa ? (
                <div className="space-y-4">
                    <p className="text-gray-700">
                        Your business is already marked as HIPAA compliant.
                    </p>
                    <p className="text-gray-600">
                        If you need to sign a Business Associate Agreement (BAA), you can still access the signing link below.
                    </p>
                    <button
                        onClick={handleMarkHipaa}
                        disabled={isSaving || isRedirecting}
                        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {(isSaving || isRedirecting) ? 'Redirecting...' : 'Sign BAA'}
                    </button>
                </div>
            ) : (
                <div className="space-y-4">
                    <p className="text-gray-700">
                        Your business is not currently marked as HIPAA compliant.
                    </p>
                    <p className="text-gray-600">
                        Click the link below to mark your account as HIPAA and sign a Business Associate Agreement (BAA).
                    </p>
                    <button
                        onClick={handleMarkHipaa}
                        disabled={isSaving || isRedirecting}
                        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {(isSaving || isRedirecting) ? 'Processing...' : 'Mark as HIPAA and Sign BAA'}
                    </button>
                </div>
            )}
        </div>
    );
}

export default MarkHipaa;
